module.exports = __webpack_public_path__ + "img/P1.d95bf4d8.png";